import React from 'react';
import { useTranslation } from 'react-i18next';
import noConnectionLogo from '@assets/connectionIcons/noConnectionLogo.png';
import ColorButton from '@components/UI/ColorButton';
import Logo from '@/components/UI/Logo';
import './NoConnectionScreen.css';
import BackToWebviewButton from '@components/common/BackToWebViewButton/BackToWebviewButton';

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#46ABD5',
    paddingTop: 14,
    paddingBottom: 70,
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  text: {
    fontWeight: '600',
    color: 'white',
    fontSize: 14,
    textAlign: 'center',
  },
  noConnectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 47,
  },
  button: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '12px 0',
    backgroundColor: '#ECF7FB',
    borderRadius: '30px',
    maxWidth: '400px',
  },
  buttonText: {
    fontWeight: '700',
    color: '#46ABD5',
    fontSize: 18,
  },
};

function NoConnectionScreen({ networkName }) {
  const { t } = useTranslation();
  return (
    <div
      className="container"
      style={styles.container}
    >
      <BackToWebviewButton className="backToWebViewButton" />
      <Logo className="logo" />

      <div style={styles.noConnectionContainer}>
        <img
          alt="noConnectionLogo"
          src={noConnectionLogo}
          style={{ maxWidth: '69%', height: 'auto' }}
        />
        <p
          style={styles.text}
          dangerouslySetInnerHTML={{
            __html: `${t('pleaseCheckWifi')} ${networkName ? `"${networkName}"` : ''} ${t('andOffVPN')}`,
          }}
        />
      </div>

      <ColorButton
        onClick={() => window.location.reload(false)}
        style={styles.button}
      >
        <span style={styles.buttonText}>
          {t('tryAgain')}
        </span>
      </ColorButton>
    </div>
  );
}

export default NoConnectionScreen;
